import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import DeviceHistoryPage from '../pages/DeviceHistoryPage';

/** Same device history as the history page, kept on the dashboard. */
export default function DeviceHistoryModal({ deviceId, serialNumber = '', onClose }) {
  const [currentId, setCurrentId] = useState(deviceId);
  const [currentSerial, setCurrentSerial] = useState(serialNumber || '');

  useEffect(() => {
    setCurrentId(deviceId);
    setCurrentSerial(serialNumber || '');
  }, [deviceId, serialNumber]);

  useEffect(() => {
    if (currentId == null || currentId === '') {
      return undefined;
    }
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [currentId, onClose]);

  if (currentId == null || currentId === '' || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className="fixed inset-0 z-[60] flex items-start justify-center overflow-y-auto bg-slate-950/60 p-3 sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label="История устройства"
    >
      <button
        type="button"
        aria-label="Закрыть"
        className="fixed inset-0 cursor-default"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-5xl pb-8">
        <div className="mb-2 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="min-h-10 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 shadow-sm dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 sm:min-h-0 sm:py-1.5"
          >
            Закрыть
          </button>
        </div>
        <DeviceHistoryPage
          embedded
          deviceId={currentId}
          serialNumber={currentSerial}
          onDeviceChange={(nextId, nextSerial) => {
            setCurrentId(nextId);
            setCurrentSerial(nextSerial || '');
          }}
        />
      </div>
    </div>,
    document.body,
  );
}
